<template>
  <div
    v-if="visivel"
    id="certificarLogin"
    style="display: block; padding-top: 200px" class="w3-modal"
    v-cloak>

    <div class="modal-container w3-modal-content">
      <header class="w3-container modal-wrapper">
        <h2 class="texto-vermelho titulo"> Certificar Login </h2>
      </header>

      <login 
        certificandoLogin="S"
        @confirmarLogin="confirmarLogin"
        :dadosUsuarioLogado="dados_sessao_usuario"
        v-if="dados_sessao_usuario.tipo_autenticacao == 'UAD'"
      />

      <login-terceiros 
        certificandoLogin="S"
        @confirmarLogin="confirmarLogin"
        :dadosUsuarioLogado="dados_sessao_usuario"
        v-if="dados_sessao_usuario.tipo_autenticacao != 'UAD'"
      />

    </div>
  </div>
</template>

<script>
  import Login from '@/components/Login';
  import LoginTerceiros from '@/components/LoginTerceiros';
  import RSessao from '@/components/Rest/RSessao';

  export default {
    name: 'CertificarLogin',
    components: {
      Login,
      LoginTerceiros
    },
    data() {
      return {
        visivel: false,
        dados_sessao_usuario: undefined
      }
    },
    methods: {
      async abrir() {
        this.visivel = true;
      },

      async confirmarLogin() {
        await this.$emit('confirmarCertificarLogin');
        this.visivel = false;
      },
    },

    async created() {
      this.dados_sessao_usuario = await RSessao.getDadosSessaoUsuario();
      this.dados_sessao_usuario = await JSON.parse(JSON.stringify(this.dados_sessao_usuario));
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CertificarLogin.vue